const img = (id, w = 1000) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const products = [
  {
    id: "p5-quad",
    name: "EMV Android POS P5 Quad",
    category: "Hardware",
    tagline: "Flagship all-in-one smart POS",
    description:
      "Professional scanning module, 5.5-inch full screen with thin bezel and a high-speed thermal printer. Quad-core processor with Android 11 for better performance and lower power consumption, crafted for comfortable one-hand operation.",
    features: ["Quad-Core Cortex-A53 @ 2.0GHz", "2GB RAM + 32GB storage", "Android 11", "High-speed thermal printer (100mm/s)", "5.5\" full screen, thin bezel", "Optional charging cradle"],
    image: img("photo-1556742049-0cfed4f6a45d"),
    featured: true,
  },
  {
    id: "p5l-mini",
    name: "EMV Android Mini POS P5L",
    category: "Hardware",
    tagline: "Payments on the go",
    description:
      "Compact and portable mini POS supporting code scanning, NFC, magnetic stripe and IC cards. High-efficiency quad-core processor with Android 11 — accept payments anywhere.",
    features: ["Quad-Core Cortex-A53 @ 2.0GHz", "NFC, magstripe, IC & QR payments", "5.5\" full screen", "Android 11", "Compact & portable", "Optional scanning module"],
    image: img("photo-1599050751795-6cdaafbc2319"),
  },
  {
    id: "p5l-ssk",
    name: "Self-Service Payment Kit P5L SSK",
    category: "Hardware",
    tagline: "Unattended, frictionless checkout",
    description:
      "Built for self-service environments with IP64-level protection, IK08 impact resistance and Corning glass. Accepts QR codes, cards, NFC and e-wallets for faster, frictionless checkouts.",
    features: ["IP64 water & dust resistant", "IK08 impact resistance", "QR, card, NFC & e-wallet support", "5.5\" HD screen (1280×720)", "2GB + 32GB memory", "Wide connectivity options"],
    image: img("photo-1556740738-b6a63e27c4df"),
  },
  {
    id: "p5se",
    name: "P5SE EMV Android POS",
    category: "Hardware",
    tagline: "Android 13 speed, lower upfront cost",
    description:
      "Faster operation with a quad-core 2.0GHz processor and Android 13. All-in-one device supporting all major payment methods with fast 80mm/s receipt printing.",
    features: ["Quad-core @ 2.0GHz", "Android 13", "5.45\" touch screen", "Thermal printer up to 80mm/s", "IC, magstripe, NFC & QR", "Professional scanning module"],
    image: img("photo-1556742111-a301076d9d18"),
  },
  {
    id: "n6",
    name: "Non EMV Android POS N6",
    category: "Hardware",
    tagline: "Customisable workhorse",
    description:
      "Next-generation quad-core POS with optional Android 11/12 GMS, OS customisation and Secure Boot. Runs QR payments, queuing, ordering, vending and ticketing with ease.",
    features: ["Quad-Core 2.0GHz", "Android 11 or 12 GMS", "Secure Boot support", "High-capacity 2620mAh battery", "4G/3G/2G + dual SIM", "80mm/s high-speed printer"],
    image: img("photo-1556742212-5b321f3c261b"),
  },
  {
    id: "t2-tablet",
    name: "T2 EMV Android Tablet",
    category: "Hardware",
    tagline: "Delightful payments, anywhere",
    description:
      "Octa-core tablet POS with fingerprint unlocking, Tap on Glass contactless payments and a 7000mAh battery for 10-hour continuous trading. Slim, light and endlessly extendable.",
    features: ["Octa-Core @ 2.0GHz", "Fingerprint unlock", "Tap on Glass contactless", "7000mAh battery (10h)", "12.3mm thin, 635g light", "Wall-mount, kiosk & pinpad accessories"],
    image: img("photo-1544244015-0df4b3ffc6b0"),
    featured: true,
  },
  {
    id: "e1-lite",
    name: "E1 Lite EMV Mini ECR",
    category: "Hardware",
    tagline: "Counter-top register, reimagined",
    description:
      "Mini electronic cash register with a 6.745-inch large screen and customer-facing display. Front-top NFC antenna makes every payment customer-friendly.",
    features: ["Quad-core @ 2.0GHz, Android 13", "6.745\" screen (1600×720)", "Customer-side second display", "80mm/s thermal printing", "Front-facing NFC", "IC, magstripe, NFC & QR"],
    image: img("photo-1556742502-ec7c0e9f34b1"),
  },
  {
    id: "d5-desktop",
    name: "D5 Desktop Android POS",
    category: "Hardware",
    tagline: "Dual-screen desktop power",
    description:
      "High-performance desktop POS with a 15.6-inch main display and 10.1-inch customer screen — built for busy retail and hospitality counters.",
    features: ["15.6\" main + 10.1\" customer screen", "Android 11", "Quad-core 64-bit Cortex-A55", "Up to 4GB + 32GB memory", "Full HD optional display", "Counter-ready design"],
    image: img("photo-1556745757-8d76bdb6984b"),
  },
  {
    id: "qs5e",
    name: "QS5E QR Payment",
    category: "Hardware",
    tagline: "Scan. Pay. Confirmed aloud.",
    description:
      "Versatile QR and NFC payment device with real-time transaction updates, a 3W speaker that announces every payment, intuitive keyboard and robust battery.",
    features: ["QR code + NFC payments", "2.4\" colour screen", "3W / 110db speaker", "Intuitive keyboard", "Robust battery life", "Advanced connectivity"],
    image: img("photo-1556745753-b2904692b3cd"),
  },
  {
    id: "d80b",
    name: "D80B Thermal Receipt Printer",
    category: "Hardware",
    tagline: "230mm/s of crisp receipts",
    description:
      "High-speed thermal printer with multi-language and 1D/2D barcode printing. Plug-and-play with USB, Ethernet, Bluetooth and WiFi connectivity.",
    features: ["Prints up to 230mm/s", "1D & 2D barcode printing", "USB, RJ12, Ethernet, BT, WiFi", "Windows, Linux, MacOS compatible", "ESC/POS commands", "Compact, dust-resistant design"],
    image: img("photo-1586953208448-b95a79798f07"),
  },
  {
    id: "scanner",
    name: "Cordless Bluetooth Scanner",
    category: "Hardware",
    tagline: "Feather-light, ultra-fast scanning",
    description:
      "Cordless Bluetooth scanner for 1D/2D codes with ultra-fast recognition and pinpoint red LED accuracy. 42-hour battery life and a shake-proof, impact-proof 160g body.",
    features: ["1D/2D code scanning", "Cordless Bluetooth freedom", "42-hour battery life", "Shake & impact proof", "Plug-and-play", "Ergonomic 160g design"],
    image: "https://images.pexels.com/photos/9755391/pexels-photo-9755391.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "cashier-box",
    name: "Smart Cashier Box",
    category: "Hardware",
    tagline: "Safe, smart & compact cash control",
    description:
      "Compact cash drawer with Bluetooth-controlled opening, a three-position lock with key override, and abrasion-resistant metal wire grippers. Pairs with POS devices or works standalone.",
    features: ["Bluetooth open/close control", "Three-position key lock", "Four coin slots + cheque slot", "Abrasion & corrosion resistant", "Compact 345×355×100mm", "Standalone or paired use"],
    image: img("photo-1526304640581-d334cdbbf45e"),
  },
  {
    id: "paycloud",
    name: "Payment Solution · PayCloud PaaS",
    category: "Software",
    tagline: "One-stop fintech platform",
    description:
      "A comprehensive omni-channel payment gateway built on a PaaS platform. Merchants, PSPs and banks manage all payment processing while staying PCI DSS certified and EMV compliant.",
    features: ["Omni-channel payment gateway", "PCI DSS certified & EMV compliant", "Cards, QR & digital wallets", "Open API for e-commerce & O2O", "Business Management Center", "Cloud-native architecture"],
    image: img("photo-1551288049-bebda4e38f71"),
    featured: true,
  },
  {
    id: "wisecloud",
    name: "IoT Solution · WiseCloud",
    category: "Software",
    tagline: "Terminal lifecycle management",
    description:
      "SaaS platform for remote device management, app distribution and configuration across your entire terminal fleet — with remote desktop support and remote key injection.",
    features: ["Remote terminal management", "App distribution & configuration", "WiseViewer remote desktop", "Remote key injection (RKI/LKI)", "10M devices online", "Data-driven fleet insights"],
    image: img("photo-1518186285589-2f7649de83e0"),
  },
  {
    id: "wiseq",
    name: "QR Payment Solution · WiseQ",
    category: "Software",
    tagline: "Cloud soundbox QR ecosystem",
    description:
      "Combines cloud soundboxes, an IoT management platform and a unified payment gateway. Supports static, dynamic and customer-presented QR payments with real-time audio confirmation.",
    features: ["Unified payment gateway", "IoT device management platform", "Real-time payment broadcast", "Static, dynamic & CPM QR", "SaaS partner model", "PCI DSS security standards"],
    image: img("photo-1460925895917-afdab827c52f"),
  },
];

export const services = [
  {
    number: "01",
    slug: "payment-gateway",
    title: "Payment Gateway",
    headline: "Every payment builds trust.",
    copy: "Our secure payment gateway ensures seamless transactions, digital records and financial transparency. Every payment strengthens creditworthiness and opens doors to funding.",
    points: ["Card present & card-not-present", "Instant settlement", "Trackable transactions", "PCI DSS certified"],
    image: img("photo-1599050751795-6cdaafbc2319", 1200),
  },
  {
    number: "02",
    slug: "pos",
    title: "POS Software & Hardware",
    headline: "Tools to compete in a digital economy.",
    copy: "We provide POS software and devices that are affordable, reliable and easy to use. From inventory management to customer engagement, our systems give retailers the tools to compete.",
    points: ["Android smart POS range", "Inventory & order management", "Queuing & ticketing", "Setup, training & support"],
    image: img("photo-1556742049-0cfed4f6a45d", 1200),
  },
  {
    number: "03",
    slug: "vas",
    title: "Value-Added Services",
    headline: "New income from every till point.",
    copy: "Through our VAS platform, shop owners can sell airtime, data, electricity and subscription services. Commission-based offerings diversify income streams and keep businesses thriving.",
    points: ["Airtime & data sales", "Electricity vending", "Subscriptions & vouchers", "Commission-based income"],
    image: img("photo-1512941937669-90a1b58e7e9c", 1200),
  },
  {
    number: "04",
    slug: "tailor-made",
    title: "Tailor-Made Solutions",
    headline: "We meet you where you are.",
    copy: "Every business is unique. That's why we offer flexible models — from outright purchase to rental and subscription. Whether you're starting small or scaling up, we fit your budget.",
    points: ["Outright purchase", "Rental models", "Subscriptions", "Scale-up pathways"],
    image: img("photo-1441986300917-64674bd600d8", 1200),
  },
  {
    number: "05",
    slug: "compliance",
    title: "Compliance & Training",
    headline: "Building fundable, resilient businesses.",
    copy: "We support SMMEs with compliance, bookkeeping and financial management training. By strengthening governance and transparency, we help businesses qualify for funding and build long-term resilience.",
    points: ["Bookkeeping support", "Financial management training", "Governance & transparency", "Funding readiness"],
    image: img("photo-1531482615713-2afd69097998", 1200),
  },
  {
    number: "06",
    slug: "partnerships",
    title: "Partnerships & Bulk Buying",
    headline: "Lower costs, higher margins.",
    copy: "Through collective agreements with suppliers and wholesalers, we enable retailers to access bulk buying discounts and shared logistics — lowering costs and boosting profitability.",
    points: ["Bulk buying discounts", "Shared logistics", "Supplier agreements", "Community buying power"],
    image: img("photo-1552664730-d307ca884978", 1200),
  },
];

export const heroSlides = [
  {
    id: "gateway",
    overline: "Payment Gateway Solutions",
    lines: ["Payments that move", "as fast as you do"],
    copy: "A secure payment gateway for seamless transactions, digital records and financial transparency — online and in-store.",
    cta: { label: "Explore the Gateway", to: "/services" },
    image: "https://images.unsplash.com/photo-1599050751795-6cdaafbc2319?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxjb250YWN0bGVzcyUyMHBheW1lbnQlMjBtYWNoaW5lfGVufDB8fHx8MTc4NzY2NjQ2NXww&ixlib=rb-4.1.0&q=85",
    alt: "Customer paying with a smartphone over a card reader",
  },
  {
    id: "pos",
    overline: "POS Software & Hardware",
    lines: ["Point-of-sale built", "for real business"],
    copy: "Affordable, reliable Android POS devices and software — from inventory management to customer engagement.",
    cta: { label: "View Our Products", to: "/products" },
    image: "https://images.unsplash.com/photo-1758519289594-8e0444825b04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBwb2ludCUyMG9mJTIwc2FsZSUyMHRlcm1pbmFsfGVufDB8fHx8MTc4NzY2NjQ2NXww&ixlib=rb-4.1.0&q=85",
    alt: "Customer paying with a credit card at a POS terminal",
  },
  {
    id: "vas",
    overline: "Value-Added Services",
    lines: ["New income streams", "from your counter"],
    copy: "Sell airtime, data, electricity and subscriptions through our VAS platform — and grow every till point.",
    cta: { label: "See What's Possible", to: "/services" },
    image: "https://images.pexels.com/photos/8475203/pexels-photo-8475203.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Small business team organising their store",
  },
];

export const faqs = [
  {
    q: "What does Dynamic App Solutions actually do?",
    a: "We're a Johannesburg-based payments and software company. We help small and medium businesses move money, manage funds and run digital transactions — through payment gateways, POS hardware and software, value-added services and custom app development.",
  },
  {
    q: "Can I rent a POS device instead of buying one?",
    a: "Yes. We offer outright purchase, rental and subscription models. Whether you're starting small or scaling up, there's a flexible option that fits your cash flow.",
  },
  {
    q: "Which areas do you serve?",
    a: "We operate across Gauteng and South Africa with remote support and on-site implementation — and Botswana is an additional market for our solutions.",
  },
  {
    q: "What can I sell through the VAS platform?",
    a: "Airtime, data, electricity and subscription services — all commission-based, so your till point becomes an extra income stream.",
  },
  {
    q: "Do you provide training and after-sales support?",
    a: "Absolutely. Every rollout includes implementation, configuration, staff training and ongoing technical support. We also offer bookkeeping and compliance training to help your business qualify for funding.",
  },
];
